import { type CognitoConfigParams } from '@air/api';

export const COGNITO_CONFIG: CognitoConfigParams = {
  authenticationFlowType: 'USER_PASSWORD_AUTH',
  mandatorySignIn: false,
  region: process.env.NEXT_PUBLIC_COGNITO_REGION!,
  userPoolId: process.env.NEXT_PUBLIC_COGNITO_USER_POOL!,
};

export const ANONYMOUS_COGNITO_CONFIG: CognitoConfigParams = {
  ...COGNITO_CONFIG,
  authenticationFlowType: 'CUSTOM_AUTH',
  userPoolId: process.env.NEXT_PUBLIC_ANONYMOUS_USER_POOL!,
};
